/* eslint-disable camelcase */
import { CustomVars } from "@companion-core/shared/app/Interfaces/tracking";

const customVarsDefault = {
  subscription_UUID: "",
  url: "",
  referrer: "",
  offer_id: "",
  vendor_id: "",
  case_UUID: "",
  authentification: 2,
};

export let customVars: CustomVars = customVarsDefault;

export const getCustomVars = () => customVars;

export const setCustomVars = (vars: CustomVars) => {
  const authValue = vars.authentification ?? vars.authentification_1;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- authentification_1 normalized to authentification
  const { authentification_1, ...varsWithoutAuth1 } = vars;
  // We send authentification_1 only in mobile
  customVars = {
    ...customVars,
    ...varsWithoutAuth1,
    ...(authValue !== undefined && { authentification: authValue }),
  };
};

export const resetCustomVars = (fieldsToNotReset: Partial<CustomVars> = {}) => {
  const { authentification_1, ...rest } = fieldsToNotReset;
  const authValue = fieldsToNotReset.authentification ?? authentification_1;
  customVars = {
    ...customVarsDefault,
    ...rest,
    ...(authValue !== undefined && { authentification: authValue }),
  };
};
